<template>
  <div class="modal-wrap">
    <div class="modal-header">
      <p class="mb-15 bold">Vem vill du ringa?</p>
    </div>
    <div class="modal-content">
        <div v-for="(customer, index) in availableToCall" :key="index" class="mb-35">
          <a v-if="customer.cellphone || customer.phone" :href="`tel:${customer.cellphone ? customer.cellphone : customer.phone  }`" class="fg-primary">{{ customer.firstname }} {{ customer.lastname }}</a>
        </div>

    </div>

    <div class="modal-buttons">
      <div class="text-center">
        <button class="width-100" @click="close">
          stäng
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'multiCall',
  data() {
    return {
    }
  },
  computed: {
    availableToCall() {
      return this.$store.state.sendSmsOrMailContactData.receivers;
    },

  },
  methods: {
    close() {
      this.$root.modalOpen = false;
    }
  }
}
</script>